import { configureStore } from '@reduxjs/toolkit'

import languagesSlice from '../features/languages/languagesSlice'
import levelsSlice from '../data/levelsSlice'
import categoriesSlice from '../data/categoriesSlice'
import gameSlice from '../features/game/gameSlice'

export default configureStore({
  reducer: {
    languages: languagesSlice,
    levels: levelsSlice,
    categories: categoriesSlice,
    game: gameSlice
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: {
  //       ignoredActions: ['game/pickCard'],
  //     },
  //   }),
})